import React from "react";
import { Tooltip } from "@sscs/ui";
import { getClassName } from "@sscs/utils";
import { formatDistanceToNow } from "date-fns";
import styles from "./secretExposure.module.scss";
const SecretExposure = ({ exposed, timestamp, className, }) => {
    const exposureClassName = getClassName({ [styles["exposed-secret"]]: exposed }, className);
    return (React.createElement("div", { className: exposureClassName },
        React.createElement("div", null, exposed ? "Exposed" : "Suppressed"),
        React.createElement("div", { className: styles["secondary-text"] },
            "Public on:",
            " ",
            !timestamp ? (React.createElement(React.Fragment, null, "?")) : (React.createElement(Tooltip, { trigger: "term", title: `First detected in ReversingLabs cloud on ${timestamp}` },
                React.createElement("small", null, formatDistanceToNow(new Date(timestamp), {
                    addSuffix: true,
                })))))));
};
export default SecretExposure;
//# sourceMappingURL=SecretExposure.js.map